import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/introConversionSagas";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dateFormat = useDateFormat();

  const {
    selectedRequestDates: { startDate, endDate },
    currentUser: { calendarStartDate, calendarEndDate }
  } = useSelector((state) => {
    let { selectedRequestDates, currentUser } = state.introConversion;
    return { selectedRequestDates, currentUser };
  }, shallowEqual);

  const dispatch = useDispatch();

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      isRangePicker
      calendarStartDate={calendarStartDate}
      calendarEndDate={calendarEndDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    />
  );
};

export default DatePicker;
